export default {
  data() {
    return {
      popupVisible: false,
    };
  },

  methods: {
    handlePopupVisibilityChange({ isVisible }) {
      this.popupVisible = isVisible;
    },
  },
};
